export class GetCountNotificationsByOrdersInput {
    orderIds: number[];
}